// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.umFOdwIbQz0tkI9_Tz4R{flex-direction:column;gap:12px;padding:0 24px 8px;display:flex}.PHrDnOZYlcSLfWwpBiVA{margin-top:4px}.rL9LKNH0imgy87CIsHO5{justify-content:center;padding:32px 0;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"formContent": `umFOdwIbQz0tkI9_Tz4R`,
	"errorText": `PHrDnOZYlcSLfWwpBiVA`,
	"loaderWrapper": `rL9LKNH0imgy87CIsHO5`
};
export default ___CSS_LOADER_EXPORT___;
